import React, {Fragment} from 'react';
import {Section, Stepper, Explanation_text, Tabs} from '../../../components';
import Typography from '@material-ui/core/Typography';
import Analytics from './Analytics/index';
import Scorecards from './Scorecards';
import ScorecardsForm from './Form/Scorecard';

import {Route, Switch} from 'react-router-dom';

export default function Home(props){
  let subscribed=(props.workspace.active_subscription_id!=null)?true:false;
  if(props.workspace.free_account==true){subscribed=true}
  if(subscribed==true && window.location.href.includes('/home')){props.history.push('/analytics/dashboards')}
  return(
    <Fragment>
    {(subscribed==false)?
    <Section icon={<img style={{width:'30px'}} src='/images/logo.png'/>} title="Welcome to ProspectSafari!">
      <Stepper dots steps={[
        {title:<Explanation_text text='home_section_first_title'/>, content:<Typography><Explanation_text text='home_section_first_text'/></Typography>},
        {title:<Explanation_text text='home_section_second_title'/>, content:<Typography><Explanation_text text='home_section_second_text'/></Typography>},
        {title:<Explanation_text text='home_section_third_title'/>, content:<Typography><Explanation_text text='home_section_third_text'/></Typography>}]}/>
    </Section>:
    <Fragment>
    {(subscribed==true)?<Tabs {...props} white tabs={[{title:'Dashboards', path:'/analytics/dashboards'}, {title:'Scorecards', path:'/analytics/scorecards'}]}/>:null}
    <Switch>
      <Route path='/analytics/dashboards'render={(route)=><Fragment><div style={{height:'15px'}}/><Analytics {...props} {...route}/></Fragment>}/>
      <Route path='/analytics/scorecards/new'render={(route)=><Fragment><div style={{height:'15px'}}/><ScorecardsForm {...props} {...route}/></Fragment>}/>
      <Route path='/analytics/scorecards/:id/edit'render={(route)=><Fragment><div style={{height:'15px'}}/><ScorecardsForm {...props} {...route}/></Fragment>}/>
      <Route path='/analytics/scorecards'render={(route)=><Fragment><div style={{height:'15px'}}/><Scorecards {...props} {...route}/></Fragment>}/>
    </Switch>
    </Fragment>
    }
    </Fragment>
  )
}
